export default __webpack_public_path__ + "static/media/letter_to_loved_ones.056e7d7a.pdf";